module.exports = __webpack_public_path__ + "img/logo13.a0145605.jpg";